import React, { useState, useEffect, Fragment } from "react";
import Container from "@material-ui/core/Container";
import { useSelector, useDispatch } from "react-redux";
import Link from "next/link";
import useTranslation from "next-translate/useTranslation";
import Formik from "./../FormikInput";
import AutoComplete from "./../FormikInput/AutoComplete";
import Typography from "@material-ui/core/Typography";
import useStyles from "./style";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import PropertySearchCard from "./../PropertySearchCard";
import PageLoader from "./../PageLoader";
import { getProperties, getProperty } from "./../../../store/actions/Property";
import { CREATE_PROPERTY } from "../../config/routes";

function SelectProperty({ onSelect, selectedProperty = {} }) {
  const classes = useStyles();
  const [showSearchBox, setShowSearchBox] = useState(true);
  const [showPageLoader, setShowPageLoader] = useState(false);
  const dispatch = useDispatch();
  const { t } = useTranslation("common");
  const fetchSuggestions = (value) => {
    dispatch(getProperties({ searchString: value }));
  };
  const PropertyData = useSelector((state) => state.PropertyReducer);

  useEffect(() => {
    if (selectedProperty._id) {
      setShowSearchBox(false);
    }
  }, []);

  useEffect(() => {
    if (selectedProperty._id) {
      setShowSearchBox(false);
    }
  }, [selectedProperty]);

  useEffect(() => {
    if (PropertyData.propertyDetail && PropertyData.propertyDetail.name) {
      setShowPageLoader(false);
      onSelect(PropertyData.propertyDetail);
    }
  }, [PropertyData.propertyDetail]);

  const handleOnSelect = (values) => {
    setShowPageLoader(true);
    dispatch(getProperty(values._id));
  };

  return (
    <Container component="main" maxWidth="md">
      <Typography component="h1" variant="h5">
        {t("select_property")}
      </Typography>
      <PageLoader
        showPageLoader={showPageLoader}
        setShowPageLoader={setShowPageLoader}
      />
      {showSearchBox ? (
        <Grid
          container
          spacing={1}
          xs={12}
          sm={12}
          justify="space-between"
          alignItems="center"
        >
          <Grid item xs={12} sm={8}>
            <Formik initialValues={{}}>
              <AutoComplete
                onSelect={handleOnSelect}
                suggestions={PropertyData.properties}
                fetchSuggestions={fetchSuggestions}
                name="name"
                value={selectedProperty.name || ""}
                label={"search_property"}
                isLoading={PropertyData.isLoading}
              />
            </Formik>
          </Grid>
          <Grid item xs={12} sm={3}>
            {/* <Link href={CREATE_PROPERTY} variant="body2">
              Can't find? Add a new Property.
            </Link> */}
          </Grid>
        </Grid>
      ) : (
        false
      )}
      {selectedProperty._id ? (
        <Fragment>
          {!showSearchBox ? (
            <Grid container xs={12} sm={12} s={2} justify="flex-end">
              <Button
                variant="outlined"
                color="secondary"
                onClick={() => {
                  setShowSearchBox(true);
                }}
              >
                {t("change_property")}
              </Button>
            </Grid>
          ) : null}
          <Grid container spacing={1} xs={12}>
            <Grid item xs={12} sm={12}>
              <PropertySearchCard {...selectedProperty} adminMode={false} />
            </Grid>
          </Grid>
        </Fragment>
      ) : null}
    </Container>
  );
}

export default SelectProperty;
